import getFolderPaneWidth from './getFolderPaneWidth';
import getLeftRailWidth from './getLeftRailWidth';
import { LEFT_RAIL_STATIC_WIDTH } from '../internalConstants';
import { getLeftNavMaxWidth } from './getMaxWidths';

/**
 * Gets the current left nav width (folder pane width + left rail width).
 * This width is used to set the width on the div, so the value of this can be 0 depending on if the
 * components are being shown or hidden
 * @returns width in pixels
 */
export default function getLeftNavWidth(): number {
    const totalWidth = getFolderPaneWidth() + getLeftRailWidth();

    /**
     * If totalWidth is 0, the pane is in collapsed state
     */
    if (totalWidth == 0) {
        return LEFT_RAIL_STATIC_WIDTH;
    } else {
        const leftNavMaxWidth = getLeftNavMaxWidth();

        // If the current stored width is > than the MAX width allowed for current window size
        // use the MAX width
        if (totalWidth > leftNavMaxWidth) {
            return leftNavMaxWidth;
        }
    }

    return totalWidth;
}
